import { useMemo } from "react";
import { StyledVerticalNav, StyledVerticalNavDivider } from "./index.styled";
import { getRouteMenus } from "_helpers";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Menu } from "antd";
import {
  CustomerManagementIntroducingBrokerStatusEnum,
  INTRODUCING_BROKER_ROUTE,
  KYC_ROUTE,
  ThemeModeEnum,
} from "_constants";
import { useAuthUser, useCustomerManagementStore, useMainStore } from "_hooks";
import { getOnboardingStepRoute, ONBOARDING_BLOCKED } from "_helpers";

const AppVerticalNav = (props) => {
  const { mode = "inline", routesConfig = [] } = props;
  const { pathname } = useLocation();
  const {
    main: { themeMode },
  } = useMainStore();

  const {
    customerManagement: { onboardingStatusDetails },
  } = useCustomerManagementStore();

  const { user } = useAuthUser();

  const { levelOneRouteConfig, levelTwoRouteConfig } = useMemo(() => {
    let currentRouteConfig = [...routesConfig];

    // Compute the correct onboarding route for "Verify Identity"
    const lastStep = `${onboardingStatusDetails?.lastStep || ""}`.toUpperCase();
    const isFullyOnboarded = lastStep === "FTD" || lastStep === "RDP";
    const onboardingRoute = getOnboardingStepRoute(onboardingStatusDetails);
    const verifyIdentityPath = isFullyOnboarded
      ? null
      : onboardingRoute === ONBOARDING_BLOCKED
      ? null
      : onboardingRoute;

    // Replace KYC_ROUTE path with the computed onboarding route
    const kycIndex = currentRouteConfig.findIndex(({ path }) => path === KYC_ROUTE);
    if (kycIndex !== -1) {
      if (verifyIdentityPath) {
        currentRouteConfig[kycIndex] = {
          ...currentRouteConfig[kycIndex],
          path: verifyIdentityPath,
        };
      } else {
        currentRouteConfig.splice(kycIndex, 1);
      }
    }

    if (
      user?.ibStatus !==
        CustomerManagementIntroducingBrokerStatusEnum.Approved ||
      !isFullyOnboarded
    ) {
      const introducingBrokerIndex = currentRouteConfig.findIndex(
        ({ path }) => path === INTRODUCING_BROKER_ROUTE
      );
      let introducingBrokerRoute = {
        ...currentRouteConfig[introducingBrokerIndex],
      };
      delete introducingBrokerRoute?.children;
      delete introducingBrokerRoute?.type;

      currentRouteConfig[introducingBrokerIndex] = introducingBrokerRoute;
    }

    const levelOneRouteConfig = currentRouteConfig.filter(
      ({ level }) => level === 1
    );
    const levelTwoRouteConfig = currentRouteConfig.filter(
      ({ level }) => level === 2
    );
    return { levelOneRouteConfig, levelTwoRouteConfig };
  }, [onboardingStatusDetails, routesConfig, user?.ibStatus]);

  const theme =
    themeMode === ThemeModeEnum.LIGHT
      ? ThemeModeEnum.LIGHT
      : ThemeModeEnum.DARK;

  return (
    <StyledVerticalNav>
      <Menu
        theme={theme}
        items={getRouteMenus(levelOneRouteConfig)}
        mode={mode}
        selectedKeys={[pathname]}
      />
      <StyledVerticalNavDivider />
      <Menu
        theme={theme}
        items={getRouteMenus(levelTwoRouteConfig)}
        mode={mode}
        selectedKeys={[pathname]}
      />
    </StyledVerticalNav>
  );
};

AppVerticalNav.propTypes = {
  mode: PropTypes.string,
  routesConfig: PropTypes.array,
};

export default AppVerticalNav;
